import dayjs from 'dayjs';
import mutations from './mutations';
import { actionBuilder } from './actions';

const state = { expireDate: null };

const getters = {
  expireDate: state => state.expireDate && dayjs(state.expireDate).format('YYYY-MM-DD HH:mm:ss'),

  secondsLeft: state => {
    if (!state.expireDate) return undefined;
    const expireDate = new Date(state.expireDate);

    const diff = parseInt((expireDate.getTime() - Date.now()) / 1000);

    return diff > 0 ? diff : 0;
  },
};

const moduleBuilder = client => {
  return {
    namespaced: true,
    state,
    getters,
    actions: actionBuilder(client),
    mutations,
  };
};

export default { moduleBuilder };
